const AVAILABLE_APPLICATIONS_QUERY_KEY = "available-application";

const ACTIVE_APPLICATION_QUERY_KEY = "active-application";

const PAST_APPLICATION_QUERY_KEY = "past-application";

const USER_QUERY_KEY = "user";

const USER_DATA_INFO_QUERY_KEY = "user-data-info";

const DASHBOARD_DATA_QUERY_KEY_BUSINESS = "dashboard-data-business";

const DASHBOARD_DATA_QUERY_KEY_NON_GEMI = "dashboard-data-non-gemi";

const DASHBOARD_DATA_QUERY_KEY_CHAMBER = "dashboard-data-chamber";

const DASHBOARD_DATA_QUERY_KEY_REGION = "dashboard-data-region";

const USER_FILES_QUERY_KEY = "user-files";

const USER_XBRL_FILES_QUERY_KEY = "user-xbrl-files";

// Root key για τους μετρητές (counts) του dashboard ΥΓΕΜΗ.
// Τα counts κλειδώνονται ως [CHAMBER_COUNT_QUERY_KEY, "<countName>"].
const CHAMBER_COUNT_QUERY_KEY = "chamberCount";

export {
  CHAMBER_COUNT_QUERY_KEY,
  USER_FILES_QUERY_KEY,
  DASHBOARD_DATA_QUERY_KEY_BUSINESS,
  DASHBOARD_DATA_QUERY_KEY_NON_GEMI,
  DASHBOARD_DATA_QUERY_KEY_CHAMBER,
  AVAILABLE_APPLICATIONS_QUERY_KEY,
  ACTIVE_APPLICATION_QUERY_KEY,
  PAST_APPLICATION_QUERY_KEY,
  USER_QUERY_KEY,
  USER_DATA_INFO_QUERY_KEY,
  USER_XBRL_FILES_QUERY_KEY,
  DASHBOARD_DATA_QUERY_KEY_REGION,
};
